import { ProfileResponse } from 'mh-client';
import { LoginMethodName } from '@store/reducers/profile';

export const getUserAcctStatus = (profile?: ProfileResponse) => {
    if (!profile) return 'anonymous';
    const status = profile.accountStatus?.name;
    if (status === 'KycVerified' || status === 'Complete') return 'verified';
    return 'unverified';
};

export const passwordlessRedirect = (
    sent: boolean,
    methods: LoginMethodName[]
) => {
    if (sent) {
        return '/login/send-magic-link';
    }
    if (methods.includes('webauthn')) {
        return '/login/passkey';
    }

    if (methods.includes('password')) {
        return '/login/password';
    }

    return '/login';
};
